import React from 'react';
import Style from './style.sass';

const Code = ({html, css, onClick}) => {
  return (
    <React.Fragment>
      <div className={Style.Triangle__code}>
        <label className={Style.Triangle__codeLabel}>HTMLコード</label>
        <input type='text' readOnly className={Style.Triangle__htmlCode} value={html} onClick={onClick}/>
        <label className={Style.Triangle__codeLabel}>CSSコード</label>
        <textarea readOnly className={Style.Triangle__cssCode} cols='30' rows='6' value={css} onClick={onClick}></textarea>
      </div>
    </React.Fragment>
  )
}

export default Code;